<div class="user-status">
  <div>{{ user.status | userStatus }}</div>
  @if (user.status === userStatuses.invitationSent || user.status === userStatuses.passwordReset) {
    <small>{{
      user.resetPasswordSentAt | date: 'M/d/yyyy'
    }}</small>
  }
</div>
